import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { updateFilters } from "../redux/clientProfileSearchSagas";
import MultiSelectDropdown from "../../../../components/multiSelectDropdown/multiSelectDropdown";

export const Dropdown = ({ title, slice: key }) => {
  const dispatch = useDispatch();

  const options = useSelector((state) => state.clientProfilesSearch.filters[key]);

  const selectedOptions = useSelector((state) => state.clientProfilesSearch.selectedFilters[key]);

  const onSelectChange = (data) => {
    dispatch(updateFilters({ data, key }));
  };

  return (
    <div className="filter">
      <p>{title}</p>
      <MultiSelectDropdown
        options={options}
        selectedFilters={selectedOptions}
        placeholder="Select"
        numberDisplayed={0}
        includeSelectAll
        enableOnly
        haveOnSelectChange
        onSelectChange={(data) => onSelectChange(data)}
      />
    </div>
  );
};
